// extracted by mini-css-extract-plugin
export default {"checkmark":"zUTEvFj5wHpX9OzRohlU","checked":"ns09IgiSN4ccWZUsZEW7","check":"AHYxBpnzFlIcABgif203"};